import type { FC } from 'react';
import { compose } from 'redux';
import { withDataConverter } from '@beef/react';

import RegularTariff from 'pages/ProductCard/Tariff/containers/RegularTariff';

import type { ITariffCardReactModel } from '../types';
import { simpleTariffCardAdapter } from './adapter';
import { withLegacy } from '../shared/withLegacy';
import { withHubManagerInjection } from '../shared/withHubManager';
import { withFloatingElements } from '../shared/withFloatingElements';
import { withDetectIncognitoMode } from '../shared/withDetectIncognitoMode';

export const SimpleTariffCard = compose<FC<ITariffCardReactModel>>(
  withDetectIncognitoMode,
  withLegacy,
  withHubManagerInjection,
  withFloatingElements,
  withDataConverter(simpleTariffCardAdapter),
)(RegularTariff);
